import { render, staticRenderFns } from "./PesanSukses.vue?vue&type=template&id=6c2a2b38"
import script from "./PesanSukses.vue?vue&type=script&lang=js"
export * from "./PesanSukses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports